import React from 'react';
import { map, capitalize } from 'lodash';
import PercentageValue from '../../../common/PercentageValue';
import AbsoluteValue from '../../../common/AbsoluteValue';
import { percentageValue, splitByThousands } from '../../../../helpers/NumberFormatter';
import DiffAndChange from '../../../common/DiffAndChange';

export const vendorSettings = {
    settingsForTable
};


function settingsForTable(totals, prevPeriod){
    let columns = [
        {
            id: 'vendor',
            className: 'table-text-left', 
            headerClassName: 'table-text-left',
            Header: 'Vendor',
            accessor: 'customer',
            Cell: props => <span>{props.value}</span>,
            Footer: props => <span>Total</span>,
            // width: 190
        },
       {
           id: 'content_type',
           className: 'table-text-left', 
           headerClassName: 'table-text-left',
           Header: 'Source',
           // width: 70,
           accessor: 'source',
           Cell: props => <span>{(props.value)}</span>,
           Footer: props => <span>Physical<br/>Digital<br/>NR<br/>Total</span>,
       },
                                
       {
           id: 'income',
           className: 'table-text-right', 
           headerClassName: 'table-text-right',
           Header: 'Income',
           // Cell: props => <AbsoluteValue value={props.value}></AbsoluteValue>,
           // width: 70,
           accessor: 'curr_total_income',
           Cell: props => {
               const val = Number.parseFloat(props.value).toFixed(2);
               return  <AbsoluteValue currency={true} value={Number.parseFloat(props.value)}></AbsoluteValue>
           },
           Footer: props => 
                <span>
                    <AbsoluteValue currency={true} value={totals.curr_physical_income}></AbsoluteValue><br/>
                    <AbsoluteValue currency={true} value={totals.curr_digital_income}></AbsoluteValue><br/>
                    <AbsoluteValue currency={true} value={totals.curr_nr_income}></AbsoluteValue><br/>
                    <AbsoluteValue currency={true} value={totals.curr_total_income}></AbsoluteValue><br/>
                </span>,

       },
       {
           id: 'income',
           className: 'table-text-right', 
           headerClassName: 'table-text-right',
           Header: props => <span>Income Change</span>,
           // Cell: props => <AbsoluteValue value={props.value}></AbsoluteValue>,
           // width: 70,
           accessor: 'curr_total_income',
           Cell: props => {
               const val = Number.parseFloat(props.value).toFixed(2);
               return  <DiffAndChange currency={true} className="percent-value" field="total_income" item={props.original}></DiffAndChange>
           },
           Footer: props => {
           return <span>
                <DiffAndChange currency={true} className="percent-value" field="physical_income" item={totals}></DiffAndChange><br/>
                <DiffAndChange currency={true} className="percent-value" field="digital_income" item={totals}></DiffAndChange><br/>
                <DiffAndChange currency={true} className="percent-value" field="nr_income" item={totals}></DiffAndChange><br/>
                <DiffAndChange currency={true} className="percent-value" field="total_income" item={totals}></DiffAndChange>
           </span>},
           width: 130,
           show: prevPeriod
       },
      
       {
           id: 'quantity',
           className: 'table-text-right', 
           headerClassName: 'table-text-right',
           Header: 'Quantity',
           // Cell: props => <PercentageValue field="units" item={props.original}></PercentageValue>,
           // width: 70,
           accessor: 'curr_total_quantity',
           Cell: props => <AbsoluteValue currency={false} value={Number.parseFloat(props.value)}></AbsoluteValue>,
           Footer: props => 
                <span>
                    <AbsoluteValue currency={false} value={totals.curr_physical_quantity}></AbsoluteValue><br/>
                    <AbsoluteValue currency={false} value={totals.curr_digital_quantity}></AbsoluteValue><br/>
                    <AbsoluteValue currency={false} value={totals.curr_nr_quantity}></AbsoluteValue><br/>
                    <AbsoluteValue currency={false} value={totals.curr_total_quantity}></AbsoluteValue><br/>
                </span>,
       },
       {
           id: 'quantity',
           className: 'table-text-right', 
           headerClassName: 'table-text-right',
           Header: props => <span>Quantity Change</span>,
           // Cell: props => <PercentageValue field="units" item={props.original}></PercentageValue>,
           // width: 70,
           accessor: 'curr_total_quantity',
           Cell: props => <DiffAndChange currency={false} className="percent-value" field="total_quantity" item={props.original}></DiffAndChange>,
           Footer: props => <span>
               <DiffAndChange currency={false} className="percent-value" field="physical_quantity" item={totals}></DiffAndChange><br/>
               <DiffAndChange currency={false} className="percent-value" field="digital_quantity" item={totals}></DiffAndChange><br/>
               <DiffAndChange currency={false} className="percent-value" field="nr_quantity" item={totals}></DiffAndChange><br/>
               <DiffAndChange currency={false} className="percent-value" field="total_quantity" item={totals}></DiffAndChange>
              </span>,
            width: 130,
            show: prevPeriod
       },
       {
              id: 'share',
              className: 'table-text-right', 
              headerClassName: 'table-text-right no-sort',
              footerClassName: 'table-text-right',
              Header: props => <span>Income<br /> Share</span>,
              // Cell: props => <PercentageValue field="playlists" item={props.original}></PercentageValue>,
              // width: 70,
              accessor: 'share',
              Cell: props => <span>{props.value}%</span>,
          },        
       
       /*       
       {
           id: 'nr_income',
           className: 'table-text-right', 
           headerClassName: 'table-text-right',
           Header: 'NR Income',
           // Cell: props => <AbsoluteValue value={props.value}></AbsoluteValue>,
           // width: 70,
           accessor: 'nr_income',
           Cell: props => {
               const val = val ? Number.parseFloat(props.value).toFixed(2) : null;
               return  val ? <span>{splitByThousands(val, '$')}</span> : <span>-</span>
           }

       },

       {
           id: 'nr_quantity',
           className: 'table-text-right', 
           headerClassName: 'table-text-right',
           Header: 'NR Quantity',
           // Cell: props => <PercentageValue field="units" item={props.original}></PercentageValue>,
           // width: 70,
           accessor: 'nr_quantity',
           Cell: props => <span>{splitByThousands(props.value)}</span>,
       },
       */
       /*
       {
           id: 'playlists',
           headerClassName: 'table-header-item total',
           className: 'total',
           Header: 'Playlists',
           Cell: props => <PercentageValue field="playlists" item={props.original}></PercentageValue>,
           // width: 70,
           accessor: 'curr_playlists'
       }
       */

    ];
    return columns;
}